export default "__VITE_ASSET__BMIdLMU8__"